"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConceptRequestUtil = void 0;
const types_1 = require("../main/types");
const ConceptRequest_1 = require("./ConceptRequest");
const LanguageConceptCreationRequest_1 = require("./LanguageConceptCreationRequest");
const LanguageConceptEditRequest_1 = require("./LanguageConceptEditRequest");
/* eslint-disable require-jsdoc */
class ConceptRequestUtil {
    static getConverter(category, action) {
        function tupleToString(tuple) {
            return `${tuple[0]} - ${tuple[1]}`;
        }
        switch (tupleToString([category, action])) {
            case tupleToString([types_1.ConceptMaterialCategory.Language, types_1.ConceptRequestAction.Create]):
                return LanguageConceptCreationRequest_1.LanguageConceptCreationRequest.converter;
            case tupleToString([types_1.ConceptMaterialCategory.Language, types_1.ConceptRequestAction.Edit]):
                return LanguageConceptEditRequest_1.LanguageConceptEditRequest.converter;
            default:
                return ConceptRequest_1.ConceptRequest.converter;
        }
    }
}
exports.ConceptRequestUtil = ConceptRequestUtil;
